"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userInteractionToken = void 0;
var _DmsTokenHook = require("../components/DmsTokenHook/DmsTokenHook");
const userInteractionToken = function () {
  let noInteraction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  let refreshTokenData = (0, _DmsTokenHook.getRefreshToken)();
  if (refreshTokenData === "") return;
  if (refreshTokenData && refreshTokenData !== "undefined" && !noInteraction) {
    refreshTokenData.tokenUses += 1;
  } else {
    refreshTokenData.tokenUses = 0;
  }
  sessionStorage.setItem("refresh", JSON.stringify(refreshTokenData));
};
exports.userInteractionToken = userInteractionToken;